import React from 'react';

const FileModal = ({
  mode,
  openUploadAttach,
  setOpenUploadAttach,
  showViewAttachModal,
  setShowViewAttachModal,
  selectedFiles,
  selectedRecFiles,
  setSelectedFiles,
  handleRemoveImage,
  handleInputFileChange,
  handleBeforeUploadAttach,
}) => {
  return (
    <div
      className={`modal ${showViewAttachModal ? 'show' : ''}`}
      style={{ display: showViewAttachModal ? 'block' : 'none' }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header d-flex justify-content-between align-items-center">
            <h5 className="modal-title">เอกสารแนบ</h5>
            <button
              type="button"
              className="close"
              onClick={() => setShowViewAttachModal(false)}
            >
              <span>&times;</span>
            </button>
          </div>

          {(window.location.pathname === '/payment-voucher' && Array.isArray(selectedRecFiles)) && (
            <div className="modal-body">
              <h5 className="text-start card-title mb-0 me-3">
                เอกสารจากใบรับสินค้า
              </h5>
              <div className="table-responsive mt-3" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                <table className="table table-striped table-hover">
                  <thead className="thead-dark">
                    <tr>
                      <th className="text-center" style={{ width: "5%" }}>ลำดับ</th>
                      <th className="text-center" style={{ width: "75%" }}>ชื่อไฟล์</th>
                      <th className="text-center" style={{ width: "10%" }}>ดู</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedRecFiles.length > 0 ? (
                      selectedRecFiles.map((data, index) => (
                        <tr key={index}>
                          <td className="text-center">{index + 1}</td>
                          <td className="text-center">{data.slice(-20)}</td>
                          <td className="text-center">
                            <button
                              className="btn btn-link btn-sm px-3"
                              onClick={() => window.open(`${data}`, "_blank")}
                            >
                              <i className="fa fa-eye" style={{ color: "rgb(239, 108, 0)", fontSize: "16px" }} />
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3} className="text-center">
                          <h5>ไม่พบข้อมูล</h5>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div className="modal-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="text-nowrap card-title mb-0 me-3">เอกสารแนบ{{
                "/deposit-document": "ใบมัดจำ",
                "/purchase-request": "ใบขอซื้อ",
                "/purchase-order": "ใบสั่งซื้อ",
                "/product-receipt": "ใบรับสินค้า",
                "/payment-voucher": "ใบสำคัญจ่าย",
                "/bill-of-lading": "ใบเบิก",
                "/icebox": "ใบยืมสินค้า",
                "/technical-equip-form": "ใบเบิกอุปกรณ์ช่าง",
                "/office-equip-form": "ใบเบิกวัสดุใช้ภายใน",
                "/quotation": "ใบเสนอราคา",
                "/order-product": "ใบออเดอร์สินค้า",
                "/billofsale": "ใบขาย",
                "/picking-list": "Picking List",
                "/bill": "ใบวางบิล",
                "/invoice": "ใบกำกับภาษี",
                "/tax": "หนังสือหัก ณ ที่จ่าย"
              }[window.location.pathname] || ""}</h5>
              {mode !== "S" && (
                <button
                  className="btn text-white"
                  style={{
                    backgroundColor: "rgb(239, 108, 0)",
                    whiteSpace: "nowrap",
                    padding: "10px 20px",
                    fontSize: "15px",
                  }}
                  onClick={handleBeforeUploadAttach}
                >
                  แนบไฟล์
                </button>
              )}
            </div>
            <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
              <table className="table table-striped table-hover">
                <thead className="thead-dark">
                  <tr>
                    <th className="text-center" style={{ width: "5%" }}>ลำดับ</th>
                    <th className="text-center" style={{ width: "75%" }}>ชื่อไฟล์</th>
                    <th className="text-center" style={{ width: "10%" }}>ดู</th>
                    {mode === "U" && (
                      <th className="text-center" style={{ width: "10%" }}>ลบ</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {selectedFiles.length > 0 ? (
                    selectedFiles.map((data, index) => (
                      <tr key={index}>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-center">{data.slice(-20)}</td>
                        <td className="text-center">
                          <button
                            className="btn btn-link btn-sm px-3"
                            onClick={() => window.open(`${data}`, "_blank")}
                          >
                            <i className="fa fa-eye" style={{ color: "rgb(239, 108, 0)", fontSize: "16px" }} />
                          </button>
                        </td>
                        {mode === "U" && (
                          <td className="text-center">
                            <button
                              className="btn btn-link btn-sm px-3"
                              onClick={() => handleRemoveImage(index)}
                            >
                              <i className="fa fa-trash-alt" style={{ color: "rgb(239, 108, 0)", fontSize: "16px" }} />
                            </button>
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={mode === "U" ? 4 : 3} className="text-center">
                        <h5>ไม่พบข้อมูล</h5>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileModal;